export const CURRENCIES = {
  EUR: { symbol: '€', name: 'Euro', rate: 1.0 },
  USD: { symbol: '$', name: 'US Dollar', rate: 1.08 },
  GBP: { symbol: '£', name: 'British Pound', rate: 0.86 },
  PLN: { symbol: 'zł', name: 'Polish Złoty', rate: 4.32 },
  CZK: { symbol: 'Kč', name: 'Czech Koruna', rate: 25.30 },
  SEK: { symbol: 'kr', name: 'Swedish Krona', rate: 11.45 },
  NOK: { symbol: 'kr', name: 'Norwegian Krone', rate: 11.72 },
};

export const FREE_SHIPPING_THRESHOLD_EUR = 100;

export function formatPrice(eurAmount, currencyCode = 'EUR') {
  if (eurAmount == null || isNaN(eurAmount)) return '—';
  const currency = CURRENCIES[currencyCode] || CURRENCIES.EUR;
  const converted = Number(eurAmount) * currency.rate;
  const num = converted.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // These currencies place the symbol after the amount
  if (['PLN', 'CZK', 'SEK', 'NOK'].includes(currencyCode)) {
    return `${num} ${currency.symbol}`;
  }
  return `${currency.symbol}${num}`;
}

export function formatThreshold(currencyCode = 'EUR') {
  return formatPrice(FREE_SHIPPING_THRESHOLD_EUR, currencyCode);
}

export function convertPrice(eurAmount, currencyCode = 'EUR') {
  if (eurAmount == null || isNaN(eurAmount)) return 0;
  const currency = CURRENCIES[currencyCode] || CURRENCIES.EUR;
  return Number(eurAmount) * currency.rate;
}
